import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Typography, notification } from 'antd';
import { CampaignForm } from './CampaignForm';

/** `/campaigns/new`; Duplicate on the list arrives here with the source campaign in the location state. */
export function CreateCampaign() {
    const history = useHistory();
    const location = useLocation();
    const duplicateOf = location.state?.duplicateOf ?? null;
    const seed = duplicateOf ? { ...duplicateOf, name: `${duplicateOf.name} (copy)`, status: 'draft' } : null;

    const onSaved = () => {
        notification.success({ message: 'Campaign created' });
        history.push('/campaigns');
    };

    return (
        <div style={{ padding: '24px 32px' }}>
            <Typography.Title level={3}>{duplicateOf ? `Duplicate "${duplicateOf.name}"` : 'New campaign'}</Typography.Title>
            <CampaignForm key={duplicateOf?.id ?? 'new'} campaign={seed} onSaved={onSaved} submitLabel="Create campaign" />
        </div>
    );
}
